export const COLUMNS = [{
  slots: {
    title: '等级'
  },
  dataIndex: 'leve',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '职级名称'
  },
  dataIndex: 'property',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '销售分佣方式'
  },
  dataIndex: 'personal',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '创建时间'
  },
  dataIndex: 'time',
  key: '5',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 350,
  key: '6'
}];
export const data = [{
  leve: 1,
  property: '代理合伙人',
  personal: '固定比例',
  time: '2020-12-30 12:45',
  id: 1
}];